<template lang="pug">
  .block
    WtRadioQuestionInput
      template(v-slot:label)
        br
      template(v-slot:radioOne v-if="isAdminBuilder")
        BRadio.test(
          v-model="action"
          native-value="add"
          size="is-large"
        ) Add members
      template(v-slot:radioTwo)
        BRadio.test(
          v-model="action"
          native-value="invite"
          size="is-large"
        ) Invite members
      template(v-slot:radioThree)
        BRadio.test(
          v-model="action"
          native-value="skip"
          size="is-large"
        ) No, skip this step
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";

const INVITE = "invite";
const ADD = "add";

export default {
  name: "TeamBuilderAddMembersQuestions",

  components: { WtRadioQuestionInput },

  data() {
    return {
      action: ""
    };
  },

  computed: {
    ...mapGetters("challengeBuilder", ["formData"]),
    ...mapGetters("authMember", ["isAdmin"]),

    isAdminBuilder() {
      return /admin/.test(this.$route.path);
    },

    includeType() {
      return this.isAdmin ? `${ADD} or ${INVITE}` : INVITE;
    },

    includePrompt() {
      return `${this._.upperFirst(this.includeType)} ${
        this.participantType
      }s now`;
    }
  },

  watch: {
    action: {
      handler: function() {
        this.$emit("actionSelected", this.action);
      },
      immediate: true
    }
  },

  mounted() {
    if (this.isAdminBuilder) {
      this.updateTeamMembersInviteMode(ADD);
    } else {
      this.updateTeamMembersInviteMode(INVITE);
    }
  },

  methods: {
    ...mapActions("teams", ["updateTeamMembersInviteMode"])
  }
};
</script>
